export enum PlanningType {
	Classic = 1,
	Google = 2,
}